import { Drawer } from '@mantine/core';
import { useGlobal } from '../../../hooks/global';
import { background, text } from '../../../theme';
import { ICONS_MAPPER } from '../../Modals/ModalMessageModel/form';
import { VariableButton } from '../../Modals/ModalMessageModel/form/style';
import { VARIABLES } from '../../../utils/variables';

interface IProps {
    opened: boolean;
    close: () => void;
}

export const DrawerVariables = ({ opened, close }: IProps) => {
    const { theme, notifyBottom } = useGlobal();

    const copyText = (textToCopy: string) => {
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                notifyBottom("Variável copiada para área de tranferência!", "success");
            })
            .catch((err) => {
                notifyBottom("Erro ao copiar a variável para a área de tranferência!", "error");
            });
    };

    return (
        <Drawer position='right' withCloseButton={true} zIndex={800} opened={opened} onClose={close} title="Variáveis" styles={{
            content: {
                backgroundColor: background[theme]
            },
            header: {
                backgroundColor: background[theme],
                color: text[theme]
            }
        }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, minWidth: 300, flex: 1, marginTop: '20px' }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ fontSize: 14, color: text[theme] }} >
                        Clique em uma variável para copiar a chave correspondente.
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 10, padding: 10, overflow: "auto", marginLeft: -10 }}>
                    {VARIABLES.map((v) => (
                        <VariableButton onClick={() => copyText(`{{${v.value}}}`)} key={v.value} theme={theme} style={{ color: text[theme] }}>
                            {ICONS_MAPPER[v.type]} {v.label}
                        </VariableButton>
                    ))}
                </div>
            </div>
        </Drawer>
    )
}
